<style>
.info {
    color: #999;
    font-size: 12px;
    font-weight: bold;
}

input {
    width: 100%;
}

textarea {
    width: 100%;
    height: 300px;
}

.type-badge {
    padding: 8px;
    border-radius: 15px;
    color: white;
    font-size: 12px;
    display: inline-block;
    line-height: 1em;
    cursor: pointer;
    margin-right: 5px;
    margin-bottom: 5px;
    user-select: none;
}

.type-badge-selected {
    border: 5px solid gray;
    border-radius: 20px;
}

#fileElem {
    display: none;
}

.inputs {
    margin-top: 15px;
}

.pell {
    border-radius: 10px;
    border: 1px solid #ccc;
    margin: 0 0 0.5em 0;
    margin-top: 5px;
}

.input-holder {
    margin-bottom: 10px;
}

input {
    margin-top: 5px;
}

.item-type-holder {
    margin-top: 5px;
}

:global(.pell-content) {
    resize: vertical !important;
    height: 100px !important;
}

:global(.pell-actionbar) {
    background: none !important;
}

:global(.pell-content img) {
    max-width: 35%;
    border-radius: 10px;
}

:global(.pell button) {
    padding: 0px;
    margin: 0px;
}

:global(.pell button:hover) {
    background-color: ghostwhite;
    color: grey;
}

.misc-notice {
    background-color: #dfb8fd;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 30px;
    margin-top: 0px;
}

@media (max-width:972px) {
	textarea {
        height: 60px;
    }

    h1 {
        margin-top: 0px;
        margin-bottom: 0px;
    }
}
</style>

<script>
import {onMount} from 'svelte';
import {push, pop} from './pt-router/Router.svelte'
import * as Common from './Common.js';
import pell from 'pell'
import { getContext } from 'svelte';
import LoginOnAddItemView from './LoginOnAddItemView.svelte';
import PollOptions from './PollOptions.svelte'
import TagAdder from './TagAdder.svelte'
import ShareSheetModal from './Sharing/ShareSheetModal.svelte'

const { open } = getContext('simple-modal');
const { close } = getContext('simple-modal');

export let itemType;
export let itemLocation;
export let appendAddedItem;

let nothingSelected = true
let fileElem
let currentUser;
let item  = {
    item_latitude : 0,
    item_longitude : 0,
    item_type: 0,
    item_title: "",
    item_content: "",
    item_createtime: 0,
    item_tags: []
}
let editor

// Only for municipal poll item
let poll_options = []

$ : refreshed = itemType && updateItemType()
$ : refreshedLocation = itemLocation && function() {
    nothingSelected = false
    item.item_latitude = itemLocation.item_latitude
    item.item_longitude = itemLocation.item_longitude
}()

$ : locationString = function() {
    if(nothingSelected) {
        return "Click on the map to set item location."
    } else {
        return item.item_latitude + ", " + item.item_longitude
    }
}()


onMount(async () => {
    /*
    if(!Common.currentUserValue) {
        Common.loginContext.update(l => "add-item/" + itemType)
        Common.CreateNotification({body: "You must login to contribute!"}, 1000)
        push('/login')
        return
    }
    */

    pell.init({
    element: editor,
    onChange: html => item.item_content = html.replace('https://ik.imagekit.io/plantogether/', 'IMG_URL/'),
    defaultParagraphSeparator: 'div',
    styleWithCSS: false,
    actions: [
        'bold',
        'underline',
        'italic',
        'strikethrough',
        'olist',
        'ulist',
        {
            name: 'link',
            result: () => {
                const url = window.prompt('Enter the link URL')
                if (url) pell.exec('createLink', url)
            }
        }
        //, {
        //     name: 'image',
        //     result: () => {
        //         addPicture()
        //     }
        // }
    ],
    classes: {
        actionbar: 'pell-actionbar',
        button: 'pell-button',
        content: 'pell-content',
        selected: 'pell-button-selected'
    }
    })
})

function afterLoginOrCreate() {
    console.log("AFTERSUBMIT")
    Common.updateLoggedInUser(() => {
        console.log("afterFunc user:", Common.currentUserValue)
        let storedItem = item
        submit(storedItem)
    })
}

function attemptSubmit() {
    if(item.item_title.length === 0) {
        alert("Item title cannot be empty!")
        return;
    }

    if(item.item_content.length === 0) {
        alert("Item content cannot be empty!")
        return;
    }

    if(!Common.currentUserValue) {
        open(LoginOnAddItemView, {afterFunc: afterLoginOrCreate, content: { fontSize: '14px', lineHeight: '1.5em'}})
        return
    }

    submit(item)
}

function submitPoll() {
    let req = {
        item: item,
        options: poll_options
    }
    console.log(req)

    Common.postData('item/poll', req)
    .then(r => {
        if(!r.ok) {
            alert("Problem adding Item. Please try again.")
            return
        }
        item.item_id = Number(r.data)
        Common.currentUser.update(c => {
            c.user_itemcount += 1;
            return c
        })
        
        push('/item/' + item.item_id)
        Common.CreateNotification({body: "Thank you for contributing!"}, 500)
        Common.NotifyNewItemBadges(currentUser)
    })
}

function submit(item) {
    item.item_userid = currentUser.user_id;

    if(item.item_type === Common.ITEMTYPE_POLL) {
        submitPoll()
        return
    }

    Common.postData('item', item)
    .then(r => {
        if(!r.ok) {
            alert("Problem adding Item. Please try again.")
            return
        }
        console.log("REACHED HERE!!!")
        item.item_id = Number(r.data)
        Common.currentUser.update(c => {
            c.user_itemcount += 1;
            return c
        })
        console.log("REACHED HERE!!!2")
        setTimeout(() => {
            push('/item/' + item.item_id)
            open(ShareSheetModal, {
                link: "https://plantogether.city/item/" + item.item_id,
                showMessage: true,
                shareString: Common.getItemTypeString(item.item_type) + ": "  + item.item_title + " on Plan Together"},
                {content: { fontSize: '14px', lineHeight: '1.5em'}});
        }, 500)
        Common.CreateNotification({body: "Thank you for contributing!"}, 500)
        Common.NotifyNewItemBadges(currentUser)
        console.log("REACHED HERE!!!3")
    })
}

const unsubsribe = Common.currentUser.subscribe(value => {
    currentUser = value
})

function updateItemType() {
    item.item_type = Number(itemType)
}

function cancel() {
    pop();
}

function insertLink() {
    let linkURL = prompt("Please enter the URL of the link you want insert:");
    if(!linkURL) {
        return
    }
    item.item_content += '[' + linkURL + ']'
}

function addPicture() {
    editor.content.focus()
    if (fileElem) {
        fileElem.click();
    }
}

function onFileAdd(e) {
    // UploadFile
    if(fileElem.files.length == 0) {
        return;
    }

    let formData = new FormData();

    Common.getData("imageuploadtoken")
    .then(data => {
        console.log(data)

        formData.append("file", fileElem.files[0]);
        formData.append("fileName", fileElem.files[0].name);
        formData.append("publicKey", "public_we5ticUsUXZ7EafhcSIbwfOjDTo=")
        formData.append("token",data.token)
        formData.append("expire",data.expire)
        formData.append("signature",data.signature)

        Common.CreateNotification({body: "Uploading Picture!"}, 500)

        fetch('https://upload.imagekit.io/api/v1/files/upload', {
            method: 'POST',
            body: formData
        })
        .then(r => {
            if(r.status != 200) {
                alert("Error uploading picture.");
                r.text().then(t => console.log(t))
                return
            }
            
            return r.json()
        })
        .then(data => {
            pell.exec('insertImage', 'https://ik.imagekit.io/plantogether/'+ data.name)
        })
    })
}
</script>
<div style="padding-bottom: 20px;">
    <h1>Add Item</h1>
    <div class="inputs">
        <div class="input-holder">
            <strong>Type</strong><br>
            <div class="item-type-holder">
                {#each [Common.ITEMTYPE_NEWS, Common.ITEMTYPE_SUGGESTION, Common.ITEMTYPE_PRAISE, Common.ITEMTYPE_CRITICISM, Common.ITEMTYPE_MISC] as item_type}
                    <div on:click={() => {(itemType = item_type), updateItemType()}} class={(itemType == item_type) ? "type-badge type-badge-selected" : "type-badge"} style={"background-color:" + Common.getItemTypeColorString(item_type) + ";"}>
                        {Common.getItemTypeString(item_type)}
                    </div>
                {/each}
                <br>
                {#if Common.currentUserValue && Common.currentUserValue.user_area_id != 0}
                    {#each [Common.ITEMTYPE_ANNOUNCEMENT, Common.ITEMTYPE_NOTICE, Common.ITEMTYPE_QUESTION, Common.ITEMTYPE_POLL] as item_type}
                        <div on:click={() => {(itemType = item_type), updateItemType()}} class={(itemType == item_type) ? "type-badge type-badge-selected" : "type-badge"} style={"background-color:" + Common.getItemTypeColorString(item_type) + ";"}>
                            {Common.getItemTypeString(item_type)}
                        </div>
                    {/each}
                {/if}
            </div>
        </div>
        <div class="input-holder">
            <strong>Location</strong><br>
            <input style="color: grey; font-size: 12px;" readonly value={locationString}><br>
        </div>
        <div class="input-holder">
            <strong>Title</strong><br>
            <input bind:value={item.item_title}><br>
        </div>


        <div class="input-holder">
            <strong>Body</strong><br>
            <div class="pell" bind:this={editor}></div>
        </div>

        <div class="input-holder">
            <strong>Tags (Optional)</strong><br>
            <p>
                <i>
                    Adding tags allows items to be easily categorized and grouped together. Existing tags will be suggested as you type. Click to add. 
                </i>
            </p>
            <TagAdder bind:selectedTags={item.item_tags} suggestedTags={[]}></TagAdder>
        </div>

        {#if itemType === Common.ITEMTYPE_POLL}
            <div class="input-holder">
                <strong>Poll Options</strong><br>
                <PollOptions bind:options={poll_options}></PollOptions>
            </div>
        {/if}
    </div>

    <input bind:this={fileElem} multipart type="file" id="fileElem" accept="image/*" style="display:none" on:change={onFileAdd}>
    <button class="submit" on:click={attemptSubmit}>Submit</button>
</div>